import { render, staticRenderFns } from "./MobileWarning.vue?vue&type=template&id=3cef284a&scoped=true"
import script from "./MobileWarning.vue?vue&type=script&lang=js"
export * from "./MobileWarning.vue?vue&type=script&lang=js"
import style0 from "./MobileWarning.vue?vue&type=style&index=0&id=3cef284a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cef284a",
  null
  
)

export default component.exports